/* @flow */
const prefix = str => `station/entity-scores/${str}`;

export const UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
export const RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

export const FETCH_ALL_ENTITY_SCORES = prefix('FETCH_ALL_ENTITY_SCORES');
export const FETCH_ENTITY_SCORES_PAGE = prefix('FETCH_ENTITY_SCORES_PAGE');
export const FETCH_ENTITY_SCORES_PAGE_SUCCESS = prefix(
  'FETCH_ENTITY_SCORES_PAGE_SUCCESS'
);
export const FETCH_ENTITY_SCORES_PAGE_FAILURE = prefix(
  'FETCH_ENTITY_SCORES_PAGE_FAILURE'
);

export const CLEAR_SCORE_SORT_OPTIONS = prefix(
  'CLEAR_SCORE_SORT_OPTIONS'
);

export const UPDATE_SCORE_SORT_OPTIONS = prefix(
  'UPDATE_SCORE_SORT_OPTIONS'
);

export const UPDATE_SCORE_SORT_DIRECTION = prefix(
  'UPDATE_SCORE_SORT_DIRECTION'
);


// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/action-types.js